// Client-side JWT decode (NO signature verification — the api re-verifies on
// every request; we trust the token transiently for UX, see ADMIN_UI §5.1.4).
// Hand-rolled base64url decoder so we don't pull in `jose` on the frontend.

export type GoogleIdTokenClaims = {
  iss: string;
  aud: string;
  sub: string;
  exp: number; // unix seconds
  iat: number;
  email: string;
  email_verified: boolean;
  name?: string;
  hd?: string;
};

export function decodeIdToken(token: string): GoogleIdTokenClaims {
  const parts = token.split('.');
  if (parts.length !== 3) throw new Error('malformed JWT: expected 3 parts');
  const payload = parts[1]!.replace(/-/g, '+').replace(/_/g, '/');
  const padded = payload + '='.repeat((4 - (payload.length % 4)) % 4);
  // `atob` exists in every modern browser + jsdom — the admin SPA never runs
  // on Node.
  const json = atob(padded);
  return JSON.parse(decodeURIComponent(escape(json))) as GoogleIdTokenClaims;
}
